export default {
  setImages(images) {
    this.$state.images = images
  },
  setHasMorePages(value) {
    this.$state.hasMorePages = value
  },
}
